(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HomeBranchDeleteController',HomeBranchDeleteController);

        HomeBranchDeleteController.$inject = ['$uibModalInstance', 'entity', 'ManageHomeBranch', 'GlobalValues','$scope'];

    function HomeBranchDeleteController($uibModalInstance, entity, ManageHomeBranch, GlobalValues,$scope) {
        var vm = this;

        vm.homeBranch = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
        	ManageHomeBranch.delete({"corpId": GlobalValues.getCorpId(),"id":vm.homeBranch.id},
                    function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();
